import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

interface BreadcrumbProps {
  separator?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ separator = "/" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const isNumeric = (str: string): boolean => {
    return !isNaN(Number(str));
  };

  const slicePathnames = pathnames?.slice(0, 2);

  const handleNavigation = (to: string, displayName: string) => {
    if (
      displayName === "edit_prescription_of_patient" ||
      displayName === t("edit_prescription_of_patient") ||
      displayName === "add_prescription_by_template" ||
      displayName === t("add_prescription_by_template")
    ) {
      navigate(-1);
    } else {
      navigate(to);
    }
  };

  return (
    <nav aria-label="breadcrumb" className="text-primary-text">
      <ol className="flex items-center space-x-0">
        {pathnames.length > 0 ? (
          <li className="text-nowrap">
            <Link
              to="/"
              className="text-body-text text-sm font-normal capitalize hover:underline"
            >
              {t("pages")} . {t("home")}
            </Link>
          </li>
        ) : (
          <li className="text-body-text text-sm capitalize">
            {t("pages")} . {t("home")}
          </li>
        )}

        {slicePathnames.map((value, index) => {
          const isLast =
            index === slicePathnames.length - 1 || (isNumeric(slicePathnames[index+1]) );
          const to = `/${slicePathnames.slice(0, index + 1).join("/")}`;

          const rawDisplayName = isNumeric(value)
            ? t("details")
            : t(value?.replaceAll("-", "_"));

          const displayName = decodeURIComponent(rawDisplayName);

          return (
            <li key={to} className="flex items-center">
              <span className="mx-2">{separator}</span>

              {isLast ? (
                <span className="text-primary-text line-clamp-1 text-sm font-bold capitalize">
                  {displayName}
                </span>
              ) : (
                <button
                  onClick={() => handleNavigation(to, value)}
                  className="text-body-text max-w-44 cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap border-none bg-transparent text-sm font-normal capitalize hover:underline"
                >
                  {displayName}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
